import { ElementState, Preview } from "@creatomate/preview";
import { getEffectColorsByOrg, getOrganizationDefaultFonts, getSubtitleDefaultPropertiesByOrg } from "components/stories/video-studio/utils";
import modificationsForAllSubtitles from "./modificationsForAllSubtitles";

const updateSubtitleStyles = async (
  burnSubtitles: boolean,
  subtitlesElements: ElementState[],
  preview: Preview,
  organization?: string,
  language?: string
) => {
  const organizationName = burnSubtitles ? organization : "";
  const fontProperties = getOrganizationDefaultFonts(organizationName || "", true, language);
  const fontEffectProperties = getEffectColorsByOrg("Rounded background", organizationName || "");
  const subtitleDefaultProperties = getSubtitleDefaultPropertiesByOrg(organizationName || "");

  const subtitleProperties = {
    ...subtitleDefaultProperties,
    ...fontProperties,
    ...fontEffectProperties
  };
  const keys = Object.keys(subtitleProperties);

  let modifications = {};

  for (let i = 0; i < keys.length; i += 1) {
    modifications = { ...modifications,
      ...modificationsForAllSubtitles(
        subtitlesElements, keys[i], subtitleProperties[keys[i]]) };
  }
  await preview.applyModifications(modifications);
};

export default updateSubtitleStyles;
